import styled from 'styled-components';
import { Row, Divider } from 'antd';

export const Topic = styled.span`
	font-size: 1rem;
	font-weight: 600;
	margin-right: 0.5rem;
`;

export const Value = styled.span`
	font-size: 1rem;
	font-weight: 400;

	@media (min-width: 1600px) {
		font-size: 0.9rem;
	}
`;

export const PercentileScoreContainer = styled.span`
	color: #2f54eb;
	font-weight: 600;
	font-size: 0.9rem;
	border-radius: 0.25rem;
	padding: 0.75rem 1rem;
	border: 1px solid #2f54eb;
	background-color: #2f54eb0d;
`;

export const Content = styled(Row)`
	margin-left: 12px;
`;

export const CustomDivider = styled(Divider)`
	margin: 0;
	height: 100%;
	border-left: 1px solid #e6e8e8;
`;

export const Label = styled.span`
	font-size: 1rem;
	font-weight: 600;
	margin-right: 0.5rem;
`;
